export {ProjectModule} from './project.module'
export {ProjectRoutingModule} from './project-routing.module'



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/project/index.ts